import withFocus from './withFocus'

export default withFocus
